const numberOfMessagesPerFetch = 10;
const loadAdditionalMessagesAt = 2;

export { numberOfMessagesPerFetch, loadAdditionalMessagesAt };
